var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ImportWizard, { ImportContext, } from "@/components/administration/import-wizard/importWizard";
import DrawerEast from "@/components/layout/drawers/drawerEast";
import DrawerNorth from "@/components/layout/drawers/drawerNorth";
import DrawerSouth from "@/components/layout/drawers/drawerSouth";
import DrawerWest from "@/components/layout/drawers/drawerWest";
import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import MenuEast from "@/components/layout/menuEast";
import MenuNorth from "@/components/layout/menuNorth";
import MenuWest from "@/components/layout/menuWest";
import PreviewEast from "@/components/layout/previews/previewEast";
import PreviewNorth from "@/components/layout/previews/previewNorth";
import PreviewSouth from "@/components/layout/previews/previewSouth";
import PreviewWest from "@/components/layout/previews/previewWest";
import { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
export default function ModuleImport() {
    var step = useParams().step;
    var navigate = useNavigate();
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var import_module = (searchParams && searchParams.get("import_module")) || undefined;
    var _b = useState(step), activeStep = _b[0], setActiveStep = _b[1];
    var importSettings = {
        modules: {},
        selectedModule: (import_module && import_module) || null,
        step: 1,
        uploaded: false,
        file: null,
        previews: {},
        charsets: {},
        charset: null,
        delimiter: null,
        delimiters: {},
        enclosure: null,
        enclosures: {},
        dateFormat: null,
        dateFormats: {},
        timeFormat: null,
        timeFormats: {},
        timeZone: null,
        timeZones: {},
        hasHeader: false,
        showFileProperties: false,
        importType: "import",
        mapping: {
            labels: {},
            rows: {},
        },
        uploadFileName: false,
    };
    var _c = useState(importSettings), settings = _c[0], setSettings = _c[1];
    function getStep(step) {
        setActiveStep(step);
    }
    return (_jsxs("div", __assign({ className: "layout overflow-hidden flex flex-col w-full h-full page" }, { children: [_jsx(Header, {}), _jsxs("div", __assign({ className: "flex h-full flex-row flex-auto overflow-hidden" }, { children: [_jsx(MenuWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto overflow-hidden bg-[var(--colors-widget)] rounded-[5px]  w-full" }, { children: [_jsx(MenuNorth, {}), _jsxs("section", __assign({ className: "relative flex flex-row flex-auto overflow-hidden z-30" }, { children: [_jsx(DrawerWest, {}), _jsxs("div", __assign({ className: "relative flex flex-col flex-auto overflow-hidden" }, { children: [_jsx(DrawerNorth, {}), _jsx("div", __assign({ className: "flex flex-row flex-auto overflow-hidden" }, { children: _jsxs("div", __assign({ className: "relative flex flex-row flex-auto overflow-hidden" }, { children: [_jsx(PreviewWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto relative overflow-hidden transition-[filter] duration-[0.4s]" }, { children: [_jsx(PreviewNorth, {}), _jsx("div", __assign({ className: "flex-auto overflow-auto relative bg-[var(--colors-bg-default)] text-[--colors-label] p-2 space-y-6 m-2 rounded-md" }, { children: _jsxs("div", __assign({ className: "mx-4" }, { children: [_jsx("h1", __assign({ className: "py-4 border-gray-200 border-b-2 text-gray-500 text-2xl" }, { children: "IMPORT" })), process.env.NODE_ENV === "development" && (_jsxs("h3", __assign({ className: "py-4" }, { children: ["STEP ", settings.step] }))), _jsx(ImportContext.Provider, __assign({ value: settings }, { children: _jsx(ImportWizard, { settings: settings, is: activeStep, goto: getStep }) }))] })) })), _jsx(PreviewSouth, {})] })), _jsx(PreviewEast, {})] })) })), _jsx(DrawerSouth, {})] })), _jsx(DrawerEast, {})] }))] })), _jsx(MenuEast, {})] })), _jsx(Footer, {})] })));
}
